import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { CustomWindow } from '../../interfaces/custom-window.interface';

interface Link {
  link: string;
  url: string;
}

declare let window: CustomWindow;

@Component({
  selector: 'dg-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements AfterViewInit {
  @Input() primaryLinks: Link[] = [
    {
      link: 'About us',
      url: 'https://www.domesticandgeneral.com/corporate/about-us',
    },
    {
      link: 'Help and advice',
      url: 'https://www.domesticandgeneral.com/content/help-advice-section/faq',
    },
    {
      link: 'Contact us',
      url: 'https://www.domesticandgeneral.com/content/contact-domestic-general',
    },
  ];

  @Input() secondaryLinks: Link[] = [
    {
      link: 'Website Terms and Conditions',
      url: 'https://www.domesticandgeneral.com/web-terms-conditions',
    },
    {
      link: 'Privacy and Cookies policy',
      url: 'https://www.domesticandgeneral.com/privacy-cookies-policy',
    },
    {
      link: 'Accessibility policy',
      url: 'https://www.domesticandgeneral.com/accessibility',
    },
  ];

  @ViewChild('Trustpilot', { static: false }) Trustpilot!: ElementRef;

  public date = Date.now();

  constructor() {}

  ngAfterViewInit() {
    if (window['Trustpilot']) {
      window.Trustpilot.loadFromElement(this.Trustpilot?.nativeElement);
    }
  }
}
